"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkUserPaymentCapacity = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const currency_utils_1 = require("./currency-utils");
const number_utils_1 = require("./number-utils");
const checkUserPaymentCapacity = (entryAmount, platformFee, currencyType, accounts) => {
    const currenciesConfig = (0, currency_utils_1.getCurrencyConfig)(currencyType);
    if (!currenciesConfig) {
        throw new Error('Currencies config not found');
    }
    const amountConfig = [{ amount: entryAmount, currency: currenciesConfig.main }];
    if (currenciesConfig.platformFee) {
        amountConfig.push({ amount: platformFee, currency: currenciesConfig.platformFee });
    }
    const totalToSpendByCurrency = amountConfig.reduce((total, { amount, currency }) => {
        if (!currency) {
            return total;
        }
        total[currency] = currency in total ? (0, number_utils_1.formatToFixed)(new bignumber_js_1.default(total[currency]).plus(amount)) : amount;
        return total;
    }, {});
    return Object.entries(totalToSpendByCurrency).map((config) => {
        const [currency, amount] = config;
        const account = accounts.find((userAccount) => (userAccount === null || userAccount === void 0 ? void 0 : userAccount.currency) == currency);
        if (!account) {
            return { currency, isValid: false };
        }
        if (account.balance < amount) {
            return { currency, isValid: false };
        }
        return { currency, isValid: true };
    });
};
exports.checkUserPaymentCapacity = checkUserPaymentCapacity;
//# sourceMappingURL=payments-utils.js.map